import { render } from "./ClienteFactura.vue?vue&type=template&id=fd87b19e&scoped=true"
import script from "./ClienteFactura.vue?vue&type=script&lang=js"
export * from "./ClienteFactura.vue?vue&type=script&lang=js"

import "./ClienteFactura.vue?vue&type=style&index=0&id=fd87b19e&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd87b19e"]])

export default __exports__